import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useMemo,
  useState,
} from "react";

export class Dictionary<T> {
  [index: string]: T;
}

export interface ConfigContextProps {
  config: Dictionary<string> | undefined;
  setConfig: Dispatch<SetStateAction<Dictionary<string> | undefined>>;
  featureFlags: Dictionary<boolean> | undefined;
  setFeatureFlags: Dispatch<SetStateAction<Dictionary<boolean> | undefined>>;
}

interface ConfigProviderProps {
  children: ReactNode;
}

const ConfigContext = createContext<ConfigContextProps | null>(null);

export const ConfigProvider = ({ children }: ConfigProviderProps) => {
  const [config, setConfig] = useState<Dictionary<string> | undefined>();
  const [featureFlags, setFeatureFlags] = useState<
    Dictionary<boolean> | undefined
  >();

  const ctxValues = useMemo<ConfigContextProps>(
    () => ({
      config,
      setConfig,
      featureFlags,
      setFeatureFlags,
    }),
    [config, featureFlags],
  );

  return <ConfigContext value={ctxValues}>{children}</ConfigContext>;
};

export default ConfigContext;
